import { render, staticRenderFns } from "./AppliedFilters.vue?vue&type=template&id=c1881ef8&"
import script from "./AppliedFilters.vue?vue&type=script&lang=js&"
export * from "./AppliedFilters.vue?vue&type=script&lang=js&"
import style0 from "./AppliedFilters.vue?vue&type=style&index=0&id=c1881ef8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports